const config = require(`./${process.env.REACT_APP_CUSTOMER}`).default;

export default config; 